import PropTypes from 'prop-types';

function FormLabel(props) {
  return (
    <label
      htmlFor={props.htmlFor || ''}
      className={`${props.display ?? 'block'} pl-8`}
    >
      <span className="inline-block font-Roboto font-medium text-neutral-700 text-small h-12 leading-regular">
        {props.text || ''}
      </span>
      {props.children}
      {props.required && <span className="pl-[2px] text-[#4952D0]">*</span>}
    </label>
  );
}

FormLabel.propTypes = {
  children: PropTypes.element,
  text: PropTypes.string,
  display: PropTypes.string,
  htmlFor: PropTypes.string,
  required: PropTypes.bool,
};

export default FormLabel;
